export const API_URL=  "https://fizjo-staging.env.booksy.pm/api/";


//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = null
// module chunks = 